export default __webpack_public_path__ + "static/media/FOCUS.5cf3e93f.png";